/**
 * =============================================================================
 * auto-add-product.js
 * =============================================================================
 * Automatically add a product based on rules
 * =============================================================================
 */

import ConditionsEvaluator from "./conditions-evaluator.js";

var AutoAddProduct = {
  propositions: [],
  engine: false,

  /**
   * Entry point
   */
  init: function(){
    this.propositions.forEach(p => {
      this.initializeProposition(p);
    });
  },

  /**
   * Add a new auto-add product rule. This MAY be called before init (e.g. from 
   * a script tag in the page using PreInitCallbacks).
   * 
   * @param {Object} rule 
   */
  addProposition: function(proposition) {
    this.propositions.push(proposition);
    this.initializeProposition(proposition);
  },

  /**
   * Setup event handlers for each trigger event within the rule. Only ever
   * initialize a given rule once.
   * 
   * @param {Object} rule 
   */
  initializeProposition: function(proposition){
    if(!proposition.initialized){
      console.log("[A-A-P] Initializing proposition / setting up handlers", proposition);
      proposition.triggerEvents.forEach(triggerEvent => { 
        document.addEventListener(triggerEvent, e => this.handleTriggerEvent(e, proposition));
      });
    }
    proposition.initialized = true;
  },

  /**
   * Handle a trigger event for a rule, checking whether the rule has been met.
   * 
   * @param {Event} e The triggered event object
   * @param {Object} rule The corresponding rule
   */
  handleTriggerEvent: async function(e, proposition){
    console.log('[A-A-P]', 'Rule triggered!', proposition);

    let evaluator = new ConditionsEvaluator(proposition);

    console.log(`evaluator`, evaluator);

    let meetsConditions = await evaluator.evaluate(e.detail);

    console.table(evaluator.report);

    // Pass all checks? Add the item to the cart
    if(meetsConditions){
      console.log('[A-A-P]', 'Attempting to add variant', proposition.variant);
      let response = await window.MP.Extensions.Cart.add([proposition.variant]);
    } else {
      console.warn(`[A-A-P]`, `Product add rejected as didn't meet conditions`);
    }
  }
}
 
export default AutoAddProduct;